import TIML from '../../../framework/timl.js';
import { ShowPage } from '../crud/shared.js';

class BillingDetails {
  static timl = `
    table.details-table
      tbody
        tr
          th ID
          td {{ item.id }}
        tr
          th Account ID
          td {{ item.accountId }}
        tr
          th Name
          td {{ item.name }}
        tr
          th Description
          td {{ item.description }}
        tr
          th Stripe Customer ID
          td {{ item.stripeCustomerId }}
        tr
          th Stripe Subscription ID
          td {{ item.stripeSubscriptionId }}
        tr
          th Stripe Price ID
          td {{ item.stripePriceId }}
        tr
          th Status
          td {{ item.status }}
        tr
          th Plan Name
          td {{ item.planName }}
        tr
          th Current Period Start
          td {{ item.currentPeriodStart }}
        tr
          th Current Period End
          td {{ item.currentPeriodEnd }}
        tr
          th Cancel At Period End
          td {{ item.cancelAtPeriodEnd }}
        tr
          th Created At
          td {{ item.createdAt }}
        tr
          th Updated At
          td {{ item.updatedAt }}
        tr
          th Created By
          td {{ item.createdBy }}
        tr
          th Updated By
          td {{ item.updatedBy }}
  `;
}

export class BillingShow extends ShowPage {
  static timl = `
    a#share-button.list-view-add-button.float-right[href="/billing/{{ Routing.params.id }}/edit"] Edit
    <Breadcrumbs title="Billing" href="/billing" nameHref="/billing/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="" suffixStyle="display:none;" suffixSeparatorStyle="display:none;">
    div#billing-details.mt-15 Loading...
  `;

  static mapItemToViewModel(item) {
    return {
      item: {
        id: item.id || '—',
        accountId: item.accountId || '—',
        name: item.name || '—',
        description: item.description || '—',
        stripeCustomerId: item.stripeCustomerId || '—',
        stripeSubscriptionId: item.stripeSubscriptionId || '—',
        stripePriceId: item.stripePriceId || '—',
        status: item.status || '—',
        planName: item.planName || '—',
        currentPeriodStart: Util.formatDate(item.currentPeriodStart) || '—',
        currentPeriodEnd: Util.formatDate(item.currentPeriodEnd) || '—',
        cancelAtPeriodEnd: item.cancelAtPeriodEnd ? 'Yes' : 'No',
        createdAt: Util.formatDate(item.createdAt) || '—',
        updatedAt: Util.formatDate(item.updatedAt) || '—',
        createdBy: item.createdBy || '—',
        updatedBy: item.updatedBy || '—'
      }
    };
  }

  static javascript() {
    super.javascript();

    API.get(API.resourceUrl('billing', Routing.params.id))
      .then(data => {
        const viewModel = this.mapItemToViewModel(data.data);
        document.querySelector('#name').innerText = viewModel.item.name;
        TIML.renderInto(document.querySelector('#billing-details'), BillingDetails, viewModel);
      });
  }
}
